<template>
  <section>
    <h2 class="h2Title">사이트 관리</h2>
    <div class="dashWrap">
      <div class="dashRow">
        <div class="dashBx">
          <v-tabs>
            <v-tabs-slider></v-tabs-slider>
            <v-tab href="#tab-1">
              <v-icon>mdi-home-edit</v-icon>
              사이트 설정
            </v-tab>

            <v-tab href="#tab-2" disabled>
              <v-icon>mdi-toolbox-outline</v-icon>
              연계 서비스 설정
            </v-tab>

            <v-tab-item value="tab-1" key="1">
              <h2 class="tit arrowLink d-flex align-center justify-space-between">
              </h2>

              <div class="formInfo">
                <v-form ref="formSite">

                  <dl class="infoCont">
                    <dt class="formInfoTxt">사이트 이름 <i class="fa fa-asterisk" aria-hidden="true"/></dt>
                    <dd class="formInfoArea">
                      <v-col class="mgr" sm="6">
                        <v-text-field v-model="setting.site.name" label="" dense flat clearable :rules="[rules.required]"/>
                      </v-col>
                    </dd>
                  </dl>
                  <dl class="infoCont">
                    <dt class="formInfoTxt">TEL <i class="fa fa-asterisk" aria-hidden="true"/></dt>
                    <dd class="formInfoArea">
                      <v-col class="mgr" sm="6">
                        <v-text-field v-model="setting.site.tel" label="" dense flat clearable :rules="[rules.required]"/>
                      </v-col>
                    </dd>
                  </dl>
                  <dl class="infoCont">
                    <dt class="formInfoTxt">FAX <i class="fa fa-asterisk" aria-hidden="true"/></dt>
                    <dd class="formInfoArea">
                      <v-col class="mgr" sm="6">
                        <v-text-field v-model="setting.site.fax" label="" dense flat clearable :rules="[rules.required]"/>
                      </v-col>
                    </dd>
                  </dl>
                  <dl class="infoCont">
                    <dt class="formInfoTxt">SMS <i class="fa fa-asterisk" aria-hidden="true"/></dt>
                    <dd class="formInfoArea">
                      <v-col class="mgr" sm="6">
                        <v-text-field v-model="setting.site.sms" label="" dense flat clearable :rules="[rules.required]"/>
                      </v-col>
                    </dd>
                  </dl>
                  <dl class="infoCont">
                    <dt class="formInfoTxt">EMAIL <i class="fa fa-asterisk" aria-hidden="true"/></dt>
                    <dd class="formInfoArea">
                      <v-col class="mgr" sm="6">
                        <v-text-field v-model="setting.site.email" label="" dense flat clearable :rules="[rules.required]"/>
                      </v-col>
                    </dd>
                  </dl>
                  <dl class="infoCont">
                    <dt class="formInfoTxt">SYSTEM EMAIL <i class="fa fa-asterisk" aria-hidden="true"/></dt>
                    <dd class="formInfoArea">
                      <v-col class="mgr" sm="6">
                        <v-text-field v-model="setting.site.systemEmail" label="" dense flat clearable :rules="[rules.required]"/>
                      </v-col>
                    </dd>
                  </dl>

                  <dl class="infoCont">
                    <dt class="formInfoTxt">신규 회원 역할 <i class="fa fa-asterisk" aria-hidden="true"/></dt>
                    <dd class="formInfoArea">
                      <v-col class="d-flex">
                        <v-col class="mgr" sm="2">
                          <v-select :items="userRoleItems" item-value="roleId" item-text="roleName" v-model="setting.user.role"
                                    dense clearable outlined flat required label="선택" :rules="[rules.required]"/>
                        </v-col>

                      </v-col>
                    </dd>
                  </dl>
                  <dl class="infoCont">
                    <dt class="formInfoTxt">신규 회원 상태 <i class="fa fa-asterisk" aria-hidden="true"/></dt>
                    <dd class="formInfoArea">
                      <v-col class="d-flex">
                        <ul v-for="(t) in userStateItems" :key="t.value">
                          <v-checkbox v-model="setting.user.state" :value="t.value" :label="t.text" hide-details :rules="[rules.required]"></v-checkbox>
                        </ul>
                      </v-col>
                    </dd>
                  </dl>
                  <dl class="infoCont">
                    <dt class="formInfoTxt">분과 / 동호회 신규 신청 상태 <i class="fa fa-asterisk" aria-hidden="true"/></dt>
                    <dd class="formInfoArea">
                      <v-col class="d-flex">
                        <ul v-for="(t) in groupStateItems" :key="t.value">
                          <v-checkbox v-model="setting.group.state" :value="t.value" :label="t.text" hide-details :rules="[rules.required]"></v-checkbox>
                        </ul>
                      </v-col>
                    </dd>
                  </dl>
                  <dl class="infoCont">
                    <dt class="formInfoTxt">주소</dt>
                    <dd class="formInfoArea">

                      <v-col>
                        <v-col class="mgr d-flex">
                          <v-text-field type="number" v-model="setting.site.zipCode" label="우편번호"
                                        @click="openZipCode"
                                        v-on:keyup.13="openZipCode"
                                        maxlength="6"
                                        :rules="[
                                      value => !value || (value.length >= 5 && value.length <= 6) || '우편번호 형식이 아닙니다.\n\r5~6자리 숫자로 입력해주세요.'
                                      ]"/>
                          <v-text-field v-model="setting.site.address" label="주소" />
                        </v-col>
                        <v-col class="mgr">
                          <v-text-field v-model="setting.site.addressDetail" label="주소상세"></v-text-field>
                        </v-col>
                      </v-col>
                      <v-dialog v-model="daumDialogVisible" max-width="500px" @click:outside="daumDialogVisible=false" @keydown.esc="daumDialogVisible=false">
                        <daum-post @complete="completeZipCode" />
                      </v-dialog>
                    </dd>
                    <dt class="formInfoTxt">주소 미리보기</dt>
                    <dd class="formInfoArea">
                      <v-col class="mgr" sm="6" v-if="setting.site.lon && geos && geos.length > 1">
                        <v-select :items="geos"
                                  v-model="geo"
                                  return-object
                                  label="검색결과" item-text="roadAddress"
                                  dense solo flat clearable
                                  outlined
                                  @change="setGeo"
                        />
                      </v-col>
                      <v-col class="mgr" sm="6" v-if="setting.site.lon">
                        <img :src="`https://naveropenapi.apigw.ntruss.com/map-static/v2/raster-cors?w=300&h=300&center=${ setting.site.lon },${ setting.site.lat }&markers=markers=type:d|size:mid|pos:${ setting.site.lon }%20${ setting.site.lat }&level=16&X-NCP-APIGW-API-KEY-ID=${ ncpApiKey }`">
                      </v-col>
                      <v-col v-else-if="!setting.site.lon && setting.site.address" e>좌표를 찾을 수 없습니다.</v-col>
                    </dd>
                  </dl>
                </v-form>
              </div>
              <div class="btnStyleBx">
                <div class="btnCommon justify-center">
                  <v-btn class="vBtn" color="#1991eb" dark @click="saveSite">
                    <v-icon left>mdi mdi-content-save</v-icon>
                    저장
                  </v-btn>
                  <v-btn class="vBtn" color="grey" dark @click="reset">
                    <v-icon left>mdi mdi-reload</v-icon>
                    취소
                  </v-btn>
                </div>
              </div>

            </v-tab-item>

            <v-tab-item value="tab-2" key="2">
              <h2 class="tit arrowLink d-flex align-center justify-space-between">
              </h2>

              <div class="formInfo">
                <v-form ref="formExt">

                  <dl class="infoCont">
                    <dt class="formInfoTxt">네이버 GEO ID <i class="fa fa-asterisk" aria-hidden="true"/></dt>
                    <dd class="formInfoArea">
                      <v-col class="mgr">
                        <v-text-field v-model="setting.ext.naver.geocoding.id" label="" dense flat clearable :rules="[rules.required]"/>
                      </v-col>
                    </dd>
                  </dl>
                  <dl class="infoCont">
                    <dt class="formInfoTxt">네이버 GEO KEY <i class="fa fa-asterisk" aria-hidden="true"/></dt>
                    <dd class="formInfoArea">
                      <v-col class="mgr">
                        <v-text-field v-model="setting.ext.naver.geocoding.key" label="" dense flat clearable :rules="[rules.required]"/>
                      </v-col>
                    </dd>
                  </dl>

                  <dl class="infoCont">
                    <dt class="formInfoTxt">네이버 Static Map ID <i class="fa fa-asterisk" aria-hidden="true"/></dt>
                    <dd class="formInfoArea">
                      <v-col class="mgr">
                        <v-text-field v-model="setting.ext.naver.staticmap.id" label="" dense flat clearable :rules="[rules.required]"/>
                      </v-col>
                    </dd>
                  </dl>

                  <dl class="infoCont">
                    <dt class="formInfoTxt">네이버 Static Map KEY <i class="fa fa-asterisk" aria-hidden="true"/></dt>
                    <dd class="formInfoArea">
                      <v-col class="mgr">
                        <v-text-field v-model="setting.ext.naver.staticmap.key" label="" dense flat clearable :rules="[rules.required]"/>
                      </v-col>
                    </dd>
                  </dl>

                  <dl class="infoCont">
                    <dt class="formInfoTxt">네이버 SMS ID <i class="fa fa-asterisk" aria-hidden="true"/></dt>
                    <dd class="formInfoArea">
                      <v-col class="mgr">
                        <v-text-field v-model="setting.ext.naver.sms.id" label="" dense flat clearable :rules="[rules.required]"/>
                      </v-col>
                    </dd>
                  </dl>

                  <dl class="infoCont">
                    <dt class="formInfoTxt">네이버 API ID <i class="fa fa-asterisk" aria-hidden="true"/></dt>
                    <dd class="formInfoArea">
                      <v-col class="mgr">
                        <v-text-field v-model="setting.ext.naver.api.id" label="" dense flat clearable :rules="[rules.required]"/>
                      </v-col>
                    </dd>
                  </dl>
                  <dl class="infoCont">
                    <dt class="formInfoTxt">네이버 API KEY <i class="fa fa-asterisk" aria-hidden="true"/></dt>
                    <dd class="formInfoArea">
                      <v-col class="mgr">
                        <v-text-field v-model="setting.ext.naver.api.key" label="" dense flat clearable :rules="[rules.required]"/>
                      </v-col>
                    </dd>
                  </dl>

                  <dl class="infoCont">
                    <dt class="formInfoTxt">한국천문연구원 (양/음력 변환) Endpoint <i class="fa fa-asterisk" aria-hidden="true"/></dt>
                    <dd class="formInfoArea">
                      <v-col class="mgr">
                        <v-text-field v-model="setting.ext.lunar.endpoint" label="" dense flat clearable :rules="[rules.required]"/>
                      </v-col>
                    </dd>
                  </dl>
                  <dl class="infoCont">
                    <dt class="formInfoTxt">한국천문연구원 (양/음력 변환) KEY <i class="fa fa-asterisk" aria-hidden="true"/></dt>
                    <dd class="formInfoArea">
                      <v-col class="mgr">
                        <v-text-field v-model="setting.ext.lunar.key" label="" dense flat clearable :rules="[rules.required]"/>
                      </v-col>
                    </dd>
                  </dl>
                  <dl class="infoCont">
                    <dt class="formInfoTxt">Google Analytics ID <i class="fa fa-asterisk" aria-hidden="true"/></dt>
                    <dd class="formInfoArea">
                      <v-col class="mgr">
                        <v-text-field v-model="setting.ext.analytics.id" label="" dense flat clearable :rules="[rules.required]"/>
                      </v-col>
                    </dd>
                  </dl>

                </v-form>
              </div>

              <div class="btnStyleBx">
                <div class="btnCommon justify-center">
                  <v-btn class="vBtn" color="#1991eb" dark @click="saveExt">
                    <v-icon left>mdi mdi-content-save</v-icon>
                    저장
                  </v-btn>
                  <v-btn class="vBtn" color="grey" dark @click="reset">
                    <v-icon left>mdi mdi-reload</v-icon>
                    취소
                  </v-btn>
                </div>
              </div>

            </v-tab-item>
          </v-tabs>

        </div>
      </div>
    </div>

  </section>
</template>

<script>
import settingApi from '@/api/SettingApi'
import utilApi from "@/api/UtilApi";
import roleApi from "@/api/RoleApi";

import _ from 'lodash';

export default {
  name: "Settings",
  components: {
  },
  props: {
    id: String
  },
  data: () => ({
    setting: {
      user: {
        state:'STATE_REQUEST',
      },
      group: {
        state:'STATE_REQUEST'
      },
      site:{
        name: 'e-CLUB 전자사랑모임'
      },
      ext:{
        naver: {
          geocoding:{},
          staticmap:{},
          sms:{},
          api:{}
        },
        lunar: {
          endpoint: '-',
          key: '-'
        },
        analytics: {
          id: '-'
        }
      }
    },
    userStateItems: [
      {text: '승인', value: 'STATE_NORMAL'},
      {text: '대기', value: 'STATE_REQUEST'},
      {text: '심사중', value: 'STATE_EXAMINATION'},
      {text: '반려', value: 'STATE_REJECT'},
      {text: '탈퇴', value: 'STATE_WITHDRAW'},
      {text: '탈퇴대기', value: 'STATE_WITHDRAW_REQUEST'},
      {text: '휴면', value: 'STATE_DORMANT'},
      {text: '차단', value: 'STATE_BLOCKED'}
    ],
    groupStateItems: [
      {text: '승인', value: 'STATE_APPROVAL'},
      {text: '대기', value: 'STATE_REQUEST'},
      {text: '거절', value: 'STATE_DENIED'},
    ],
    userRoleItems: [],
    daumDialogVisible: false,
    rules: {
      required: value => !!value || '필수 입력 항목입니다..',
      qtZero: value => value && value > 0 || '필수 입력 항목입니다.'
    },
    meeting: {
      title: null,
      zipCode: null,
      address: null,
      meetingContents: null,
      entryFee: 0,
      activated: true,
      group : {
        parentId : 1
      },
      groupId : null,
      lon:null,
      lat:null
    },
    startCal: false,
    endCal: false,
    postCal: false,
    imageFileUrl: null,
    endPoint: process.env.VUE_APP_ATTACH_FILE_SERVER_URL,
    fileMeta: {},
    geos:[],
    errStartTm:false,
    errEndTm:false,
    stateItems:[
      {text:'마감', value:'STATE_END'},
      {text:'접수중', value:'STATE_RECEIPT'},
      {text:'접수대기', value:'STATE_READY'}
    ]
  }),
  computed: {
    geo() {
      return this.geos.filter(g => g.x === this.meeting.lon && g.y === this.meeting.lat)?.[0]??null
    },
    ncpApiKey() {
      return this.$store.state.config.ext.naver.staticmap.id
    }
  },
  methods: {
    setGeo(item) {
      this.setting.site.lon = item.x
      this.setting.site.lat = item.y
    },
    openZipCode() {
      this.daumDialogVisible = true;
    },
    completeZipCode(data) {
      this.setting.site.zipCode = data.zonecode
      this.setting.site.address = data.address

      utilApi.geo(data.address).then(res => {
        if(res.status === 'OK') {

          this.setting.site.lon = res.addresses[0]?.x;
          this.setting.site.lat = res.addresses[0]?.y;
          this.geos = res.addresses;
        }
      });

      this.daumDialogVisible = false;
    },
    goList() {
      this.$router.push({path: '/group/meeting'})
    },
    async saveSite() {

      if (!await this.$refs.formSite.validate())
        return;

      this.save();
    },
    async saveExt() {

      if (!await this.$refs.formSite.validate())
        return;

      this.save();

    },
    save() {
      settingApi.save(this.setting).then(data => {
        if (data) {
          if (this.meeting.meetingId) {
            alert("수정되었습니다.");
          } else {
            alert("등록되었습니다.");
          }
        } else {
          alert("Error");
        }
      });
    },
    reset() {
      settingApi.get().then(data => {
        this.setting = data;
      });
    }


  },
  created() {
    settingApi.get().then(data => {
      this.setting = _.merge(this.setting, data);
    });

    roleApi.list(true).then(data => {
      this.userRoleItems = data;
    });

  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/style/layout/variables';

.h2Title {
  @include h2-title;
}

.formInfo {
  @include form-info;
}

.userDd {
  padding: 10px 0;
}

.list {
  overflow: hidden;
}
</style>